// This import loads the firebase namespace along with all its type information.
import GameLog from './game-log-model'

export async function load_gameLogs(): Promise<GameLog[]> {
  throw 'Not implemented'
}

export async function delete_gameLog(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_gameLog(): Promise<GameLog> {
  throw 'Not implemented'
}
